import React from 'react';
import { Box, Typography, Paper, makeStyles } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#02172a',
    minHeight: '100vh',
    maxWidth: '900px',
    margin: '0 auto',
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  title: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: '#b0b0b0',
    fontSize: '1rem',
  },
  paper: {
    padding: theme.spacing(3),
    backgroundColor: '#1a2332',
    border: '1px solid #2a3a4a',
    borderRadius: 12,
    color: '#fff',
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    color: '#1976d2',
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
}));

const SystemSettings: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.header} display="flex" alignItems="center">
        <SettingsIcon style={{ color: '#1976d2', marginRight: 12, fontSize: 32 }} />
        <Box>
          <Typography variant="h4" className={classes.title}>
            System Settings
          </Typography>
          <Typography className={classes.subtitle}>
            Configure application and API settings.
          </Typography>
        </Box>
      </Box>

      <Paper className={classes.paper} elevation={0}>
        <Box className={classes.section}>
          <Typography className={classes.sectionTitle}>General</Typography>
          <Typography variant="body2" style={{ color: '#b0b0b0' }}>
            API URL and environment settings are typically configured at build time or via environment variables.
            Contact your administrator to change backend or feature settings.
          </Typography>
        </Box>
        <Box className={classes.section}>
          <Typography className={classes.sectionTitle}>Dashboard</Typography>
          <Typography variant="body2" style={{ color: '#b0b0b0' }}>
            Dashboard data (revenue, signups, analytics) is loaded from the configured API. Ensure the backend is deployed and reachable.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SystemSettings;
